import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { SinisterService } from '../../../../services/table-management/sinister.service';
import { SinisterFormComponent } from '../sinister-form/sinister-form.component';

@Component({
  selector: 'app-sinister-list',
  templateUrl: './sinister-list.component.html',
  styleUrls: ['./sinister-list.component.css'],
  providers:[SinisterService],
  standalone: false,
})
export class SinisterListComponent extends EntityListComponent<Rest.InvSinister> implements OnInit {

  @ViewChild(SinisterFormComponent, { static: true })
    sinisterForm: SinisterFormComponent;
  
    title: string = this.translateService.instant('tableManagement.sinister.sinister');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    isCreateGranted: boolean;
    isDelegationUser: boolean;
    isDeleteGranted: boolean;

    @Input() vehicle: Rest.Vehicle;
  
    constructor(
      private sinisterService: SinisterService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        sinisterService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.sinisterService = sinisterService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.sinisterForm;
      this.setPermissions();
    }
    beforeLoad() {
      if (this.vehicle) this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];   
      this.paginationRequest.sortAsc= false;
    }
  
    afterLoad() {
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.sinister.sinister');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {

      const vehicle = (entity: any) => entity.vehicle.name ?? '';
      const referenceNumber = (entity: any) => entity.referenceNumber ?? '';
      const driver = (entity: any) => `${entity.driver?.employee?.user?.surname1 ?? ''} ${entity.driver?.employee?.user?.surname2 ?? ''},  ${entity.driver?.employee.user?.name ?? ''}`;
      const sinisterType = (entity: any) => entity.sinisterType.name ?? '';
      const sinisterDate = (entity: any) => entity.sinisterDate ?? '';
      const sinisterTotal = (entity: any) => entity.sinisterTotal ?? '';
      const closed = (entity: any) => entity.closed ?? '';

      this.excelColumns = {
        [this.translateService.instant('general.vehicle')]: { bindField: vehicle },
        [this.translateService.instant('tableManagement.sinister.driver')]: { bindField: driver },
        [this.translateService.instant('tableManagement.sinister.referenceNumber')]: {bindField: referenceNumber},
        [this.translateService.instant('tableManagement.sinister.sinisterTypeTable')]: { bindField: sinisterType },
        [this.translateService.instant('tableManagement.sinister.sinisterDate')]: { bindField: sinisterDate },
        [this.translateService.instant('tableManagement.sinister.sinisterTotal')]: { bindField: sinisterTotal },
        [this.translateService.instant('tableManagement.sinister.closed')]: { bindField: closed },
      }
    }

    deleteSinister(sinister){
      var that = this;
      this.sinisterService.deleteById(sinister.id).then((response) =>{
        if (response) {
          that.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
          that.refresh();
        } else {
          that.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
        }
      })

    }

    public onDeleteSinister(sinister: Rest.InvSinister) {

		  if (this.isDeleteGranted === false) {
			  return;
		  }

		  this.confirmationService.confirm({
			  accept: () => {
				  this.deleteSinister(sinister);
			  },
			  key: 'sinister-list'
		  });
	  }

    setPermissions() {
		    const user = this.authenticationService.user;
		    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_SINISTER_CREATE', user);
        this.isDeleteGranted = this.authenticationService.isRoleGranted('INV_SINISTER_DISABLE', user);
        this.isDelegationUser = !this.authenticationService.isRoleGranted('INV_DELEGATIONS_ADMIN', user);

	  }

    openDialog(sinister){
      if(!this.isDelegationUser){
        this.editDialog(sinister);
      }
    }

}

